export default __webpack_public_path__ + "static/media/weblogin1.d138532b.jpg";